<template>
    <PageTitleLayout>
        <div class="searching w-full mt-4">
            <header
                class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg w-full relative overflow-visible">
                <h2 class="text-white text-lg font-bold 2xl:w-2/12 xl:w-3/12 lg:w-4/12 md:w-4/12">Weekly Calculated Totals 
                </h2>
                <div v-show="showWarningHover().length > 0" style="z-index: 2;"
                    class="2xl:w-10/12 xl:w-9/12 lg:w-8/12 md:w-8/12"> <i v-on:mouseover="upHere = true"
                        v-on:mouseleave="upHere = false"
                        class="fa fa-exclamation text-white mr-auto text-lg bg-[#cb0000] rounded-full w-[25px] h-[25px] text-center alert_icon_coustam"
                        style="font-size: 18px; line-height: 1.6; width: calc(24px) !important;"></i>
                    
                        <ul v-show="upHere" class="absolute bg-white p-4 ml-4" style="border-radius: 0px 10px 10px 10px;">
                        <li v-for="additional in showWarningHover()" class="block text-black text-sm list-disc pb-1">
                            {{ additional }}
                        </li>
                    </ul>
                </div>

                <i class="fa fa-caret-down text-white mr-5 z-10 cursor-pointer" aria-hidden="true"
                    @click="ShowHideCheckboxes()"></i>
                <div v-if="ShowHideCheckboxesCheck" v-click-outside="onClickOutside"
                    class="absolute bg-white p-5 z-20 left-auto right-0 top-[44px] overflow-scroll overflow-x-auto overflow-y-scroll h-[280px] shadow">
                    <div v-for="(checkbox, index) in weekly_calculated_checkboxes" :key="index" class="pb-[10px]">
                        <label :for="checkbox" class="text-black uppercase tracking-wider cursor-pointer"> <input
                                type="checkbox" :id="checkbox" :value="checkbox" v-model="weekly_calculated_totals">
                            {{ checkbox === 'sugar' 
                                ? 'Total Sugar' 
                                : checkbox === 'CALS (%)' 
                                    ? 'Add. Sugar %**' 
                                    : checkbox === 'SATFAT (%)' 
                                        ? 'SAT FAT %**' 
                                        : checkbox === 'satfat' 
                                            ? 'SAT FAT' 
                                            : checkbox }} 
                        
                        </label>
                    </div>
                    <!-- <p>Weekly totals: {{ weekly_calculated_totals }}</p> -->
                </div>

            </header>
        </div>
    </PageTitleLayout>

    <TableIndexLayout>
        <div class="-my-2 mt-0-down">
            <div class="py-14 align-middle inline-block xl:px-10 px-5 w-full">


                <div class="shadow overflow-x-auto">
                    <table class="min-w-full shadow rounded-t-lg overflow-hidden table-background">
                        <thead>
                            <tr class="">
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    MMA 
                                    <p class="lowercase">(oz eq)</p>
                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    GRA <p class="lowercase">(oz eq)</p>
                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    fru <p class="lowercase">(cups)</p>

                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    mlk
                                    <p class="lowercase">(cups)</p>

                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    veg
                                    <p class="lowercase">(cups)</p>

                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    dg
                                    <p class="lowercase">(cups)</p>

                                </th>

                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    r/o
                                    <p class="lowercase">(cups)</p>

                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    BPL
                                    <p class="lowercase">(cups)</p>

                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    star
                                    <p class="lowercase">(cups)</p>

                                </th>
                                <th scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    oth
                                    <p class="lowercase">(cups)</p>

                                </th>

                                <template v-for="(WeeklyCalculated, index) in datas" :key="index">
                                    <th v-if="hasValue(WeeklyCalculated.name)" scope="col"
                                        class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                        {{ WeeklyCalculated.name === 'sugar' 
                                            ? 'Total Sugar' 
                                            : WeeklyCalculated.name === 'CALS (%)' 
                                                ? 'Add. Sugar %**' 
                                                : WeeklyCalculated.name === 'SATFAT (%)' 
                                                    ? 'SAT FAT %**' 
                                                    : WeeklyCalculated.name === 'satfat' 
                                                    ? 'SAT FAT' 
                                                    : WeeklyCalculated.name == 'added_sugars'
                                                        ? 'Added Sugars'                                                
                                                        : WeeklyCalculated.name }} 
                                        <!-- {{ WeeklyCalculated.name === 'sugar' ? 'Total Sugar' : WeeklyCalculated.name }}  -->
                                        
                                        {{ WeeklyCalculated.unit ? '(' +
                                            WeeklyCalculated.unit +
                                        ')' : '' }}
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Odd row -->

                            <tr v-if="Object.keys(weeklyAvg) == 0" class="bg-white">
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>
                                <td
                                    class="px-1 py-2 text-center text-xs font-white text-black uppercase tracking-wider">
                                    <div class="button-bg-color-wed rounded min-w-min-button text-center text-white">
                                    </div>
                                </td>

                            </tr>
                            <tr v-else>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_meat', 'weekly_max_usda_componenent_serving_meat')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_meat, guideline_data.weekly_max_usda_componenent_serving_meat, $helpers.nearestValue(weeklyAvg.MMA, true), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_meat, guideline_data.weekly_max_usda_componenent_serving_meat, $helpers.nearestValue(weeklyAvg.MMA, true), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">

                                        {{ addName($helpers.nearestValue(weeklyAvg.MMA, true), 'MMA') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_meat && guideline_data.weekly_max_usda_componenent_serving_meat != 0">/{{guideline_data.weekly_max_usda_componenent_serving_meat}}</span> -->
                                    </div>

                                    <div v-else
                                        :title="showMinMax('weekly_min_usda_componenent_serving_meat', 'weekly_max_usda_componenent_serving_meat')"
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">{{ addName($helpers.nearestValue(weeklyAvg.MMA, true), 'MMA') }}</div>

                                </td>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_grain', 'weekly_max_usda_componenent_serving_grain')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_grain, guideline_data.weekly_max_usda_componenent_serving_grain, $helpers.nearestValue(weeklyAvg.WGR, true), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_grain, guideline_data.weekly_max_usda_componenent_serving_grain, $helpers.nearestValue(weeklyAvg.WGR, true), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.WGR, true),'WGR') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_grain && guideline_data.weekly_max_usda_componenent_serving_grain">/{{guideline_data.weekly_max_usda_componenent_serving_grain}}</span> -->
                                    </div>

                                    <div v-else
                                        :title="showMinMax('weekly_min_usda_componenent_serving_grain', 'weekly_max_usda_componenent_serving_grain')"
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.WGR, true), 'WGR') }}</div>
                                </td>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_fruit', 'weekly_max_usda_componenent_serving_fruit')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_fruit, guideline_data.weekly_max_usda_componenent_serving_fruit, parseFloat(weeklyAvg.FRU), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_fruit, guideline_data.weekly_max_usda_componenent_serving_fruit, parseFloat(weeklyAvg.FRU), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.FRU), 'FRU') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_fruit && guideline_data.weekly_max_usda_componenent_serving_fruit != 0">/{{guideline_data.weekly_max_usda_componenent_serving_fruit}}</span> -->
                                    </div>

                                    <div v-else
                                        :title="showMinMax('weekly_min_usda_componenent_serving_fruit', 'weekly_max_usda_componenent_serving_fruit')"
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">{{
                                            addName($helpers.nearestValue(weeklyAvg.FRU), 'FRU') }}</div>
                                </td>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_milk', 'weekly_max_usda_componenent_serving_milk')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_milk, guideline_data.weekly_max_usda_componenent_serving_milk, parseFloat(weeklyAvg.MLK), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_milk, guideline_data.weekly_max_usda_componenent_serving_milk, parseFloat(weeklyAvg.MLK), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.MLK), 'MLK') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_milk && guideline_data.weekly_max_usda_componenent_serving_milk != 0">/{{guideline_data.weekly_max_usda_componenent_serving_milk}}</span> -->
                                    </div>

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_milk', 'weekly_max_usda_componenent_serving_milk')"
                                        v-else
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.MLK), 'MLK') }}</div>
                                </td>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_veg', 'weekly_max_usda_componenent_serving_veg')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_veg, guideline_data.weekly_max_usda_componenent_serving_veg, parseFloat(weeklyAvg.VEG), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_veg, guideline_data.weekly_max_usda_componenent_serving_veg, parseFloat(weeklyAvg.VEG), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.VEG), 'VEG') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_veg && guideline_data.weekly_max_usda_componenent_serving_veg != 0">/{{guideline_data.weekly_max_usda_componenent_serving_veg}}</span> -->
                                    </div>

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_veg', 'weekly_max_usda_componenent_serving_veg')"
                                        v-else
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.VEG), 'VEG') }}</div>
                                </td>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_veggrn', 'weekly_max_usda_componenent_serving_veggrn')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_veggrn, guideline_data.weekly_max_usda_componenent_serving_veggrn, parseFloat(weeklyAvg.DG), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_veggrn, guideline_data.weekly_max_usda_componenent_serving_veggrn, parseFloat(weeklyAvg.DG), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.DG), 'DG') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_veggrn && guideline_data.weekly_max_usda_componenent_serving_veggrn != 0">/{{guideline_data.weekly_max_usda_componenent_serving_veggrn}}</span> -->
                                    </div>

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_veggrn', 'weekly_max_usda_componenent_serving_veggrn')"
                                        v-else
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.DG), 'DG') }}</div>
                                </td>

                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegred', 'weekly_max_usda_componenent_serving_vegred')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegred, guideline_data.weekly_max_usda_componenent_serving_vegred, parseFloat(weeklyAvg.RO), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegred, guideline_data.weekly_max_usda_componenent_serving_vegred, parseFloat(weeklyAvg.RO), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.RO), 'RO') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_vegred && guideline_data.weekly_max_usda_componenent_serving_vegred != 0">/{{guideline_data.weekly_max_usda_componenent_serving_vegred}}</span> -->
                                    </div>

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegred', 'weekly_max_usda_componenent_serving_vegred')"
                                        v-else
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.RO), 'RO') }}</div>
                                </td>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegleg', 'weekly_max_usda_componenent_serving_vegleg')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegleg, guideline_data.weekly_max_usda_componenent_serving_vegleg, parseFloat(weeklyAvg.BPL), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegleg, guideline_data.weekly_max_usda_componenent_serving_vegleg, parseFloat(weeklyAvg.BPL), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.BPL), 'BPL') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_vegleg && guideline_data.weekly_max_usda_componenent_serving_vegleg != 0">/{{guideline_data.weekly_max_usda_componenent_serving_vegleg}}</span> -->
                                    </div>

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegleg', 'weekly_max_usda_componenent_serving_vegleg')"
                                        v-else
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.BPL), 'BPL') }}</div>
                                </td>
                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegstar', 'weekly_max_usda_componenent_serving_vegstar')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegstar, guideline_data.weekly_max_usda_componenent_serving_vegstar, parseFloat(weeklyAvg.STAR), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegstar, guideline_data.weekly_max_usda_componenent_serving_vegstar, parseFloat(weeklyAvg.STAR), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.STAR), 'STAR') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_vegstar && guideline_data.weekly_max_usda_componenent_serving_vegstar != 0">/{{guideline_data.weekly_max_usda_componenent_serving_vegstar}}</span> -->
                                    </div>

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegstar', 'weekly_max_usda_componenent_serving_vegstar')"
                                        v-else
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.STAR), 'STAR') }}</div>
                                </td>

                                <td scope="col"
                                    class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegothr', 'weekly_max_usda_componenent_serving_vegothr')"
                                        v-if="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegothr, guideline_data.weekly_max_usda_componenent_serving_vegothr, parseFloat(weeklyAvg.OTH), 'component') != 'gray'"
                                        :class="checkGuildLineVals(guideline_data.weekly_min_usda_componenent_serving_vegothr, guideline_data.weekly_max_usda_componenent_serving_vegothr, parseFloat(weeklyAvg.OTH), 'component') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                        class="rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.OTH), 'OTH') }}
                                        <!-- <span v-if="guideline_data && guideline_data.weekly_max_usda_componenent_serving_vegothr && guideline_data.weekly_max_usda_componenent_serving_vegothr != 0">/{{guideline_data.weekly_max_usda_componenent_serving_vegothr}}</span> -->
                                    </div>

                                    <div :title="showMinMax('weekly_min_usda_componenent_serving_vegothr', 'weekly_max_usda_componenent_serving_vegothr')"
                                        v-else
                                        class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                        {{ addName($helpers.nearestValue(weeklyAvg.OTH), 'OTH') }}</div>
                                </td>


                                <template v-for="(WeeklyCalculated, index) in datas" :key="index">
                                    <td v-if="hasValue(WeeklyCalculated.name)" scope="col"
                                        class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
                                        <div :title="showMinMax(WeeklyCalculated.min, WeeklyCalculated.max)"
                                            v-if="checkGuildLineVals(guideline_data[WeeklyCalculated.min], guideline_data[WeeklyCalculated.max], parseFloat(weeklyAvg[WeeklyCalculated.name]), '') != 'gray'"
                                            :class="checkGuildLineVals(guideline_data[WeeklyCalculated.min], guideline_data[WeeklyCalculated.max], $helpers.nutritionalRounds(weeklyAvg[WeeklyCalculated.name]), '') == 'green' ? 'bg-button-color-green' : 'bg-button-color'"
                                            class="rounded min-w-min-button text-center text-white">
                                            {{ addNameStar($helpers.nutritionalRounds(weeklyAvg[WeeklyCalculated.name]),
                                                WeeklyCalculated.column_name) }}
                                        </div>

                                        <div :title="showMinMax(WeeklyCalculated.min, WeeklyCalculated.max)" v-else
                                            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
                                            {{ nutrition_facts_ash($helpers.nutritionalRounds(weeklyAvg[WeeklyCalculated.column_name]),
                                            'g') }}
                                        </div>
                                    </td>
                                </template>

                            </tr>

                        </tbody>

                    </table>
                </div>
                <div class="mt-4 "><b> * includes null values</b></div>
                <div class="mt-1 "><b> **% of Calories from</b></div>
                <div class="mt-1 "><b> ⟡ Includes user-edited values</b></div>
                
            </div>
            
        </div>
    </TableIndexLayout>
</template>


<script>
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import vClickOutside from "click-outside-vue3";




export default {

    props: ['guideline_data', 'mc_weekly_avg_prods', 'weeklyAvg', 'null_nutrient',  'getAllRecipes', 'override_components'],
    components: {
        PageTitleLayout,
        TableIndexLayout,
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    name: "WeeklyCalculatedTotals",



    data() {
        return {

            upHere: false,
            datas: [{
                name: 'MMA',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_meat',
                max: 'weekly_max_usda_componenent_serving_meat',
                unit: ''
            },
            {
                name: 'WGR',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_grain',
                max: 'weekly_max_usda_componenent_serving_grain',
                unit: ''
            },
            {
                name: 'FRU',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_fruit',
                max: 'weekly_max_usda_componenent_serving_fruit',
                unit: ''
            },
            {
                name: 'MLK',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_milk',
                max: 'weekly_max_usda_componenent_serving_milk',
                unit: ''
            },
            {
                name: 'VEG',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_veg',
                max: 'weekly_max_usda_componenent_serving_veg',
                unit: ''
            },
            {
                name: 'DG',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_veggrn',
                max: 'weekly_max_usda_componenent_serving_veggrn',
                unit: ''
            },
            {
                name: 'RO',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_vegred',
                max: 'weekly_max_usda_componenent_serving_vegred',
                unit: ''
            },
            {
                name: 'BPL',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_vegleg',
                max: 'weekly_max_usda_componenent_serving_vegleg',
                unit: ''
            },

            {
                name: 'STAR',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_vegstar',
                max: 'weekly_max_usda_componenent_serving_vegstar',
                unit: ''
            },
            {
                name: 'OTH',
                type: 'component',
                min: 'weekly_min_usda_componenent_serving_vegothr',
                max: 'weekly_max_usda_componenent_serving_vegothr',
                unit: ''
            },
            {
                name: 'CALS',
                type: '',
                min: 'weekly_min_nutrition_facts_calories',
                max: 'weekly_max_nutrition_facts_calories',
                unit: 'cals',
                column_name: 'nutrition_facts_calories'
            },
            {
                name: 'SOD',
                type: '',
                min: 'weekly_min_nutrition_facts_sodium',
                max: 'weekly_max_nutrition_facts_sodium',
                unit: 'mg',
                column_name: 'nutrition_facts_sodium'
            },
            {
                name: 'added_sugars',
                type: '',
                min: 'weekly_min_nutrition_facts_added_sugars',
                max: 'weekly_max_nutrition_facts_added_sugars',
                unit: 'g',
                column_name: 'nutrition_facts_added_sugars'
                
            },

            {
                name: 'CALS (%)',
                type: '',
                min: 'weekly_min_nutrition_facts_calspercent',
                max: 'weekly_max_nutrition_facts_calspercent',
                unit: '',
                column_name: 'nutrition_facts_calspercent'
            },

            {
                name: 'satfat',
                type: '',
                min: 'weekly_min_nutrition_facts_satfat',
                max: 'weekly_max_nutrition_facts_satfat',
                unit: 'g',
                column_name: 'nutrition_facts_satfat'
            },

            {
                name: 'SATFAT (%)',
                type: '',
                min: 'weekly_min_nutrition_facts_satfatpercent',
                max: 'weekly_max_nutrition_facts_satfatpercent',
                unit: '',
                column_name: 'nutrition_facts_satfatpercent'
            },

            {
                name: 'CARB',
                type: '',
                min: 'weekly_min_nutrition_facts_carbs',
                max: 'weekly_max_nutrition_facts_carbs',
                unit: 'g',
                column_name: 'nutrition_facts_carbs'
            },

            {
                name: 'FAT',
                type: '',
                min: 'weekly_min_nutrition_facts_totalfat',
                max: 'weekly_max_nutrition_facts_totalfat',
                unit: 'g',
                column_name: 'nutrition_facts_totalfat'
            },
            {
                name: 'PROT',
                type: '',
                min: 'weekly_min_nutrition_facts_protein',
                max: 'weekly_max_nutrition_facts_protein',
                unit: 'g',
                column_name: 'nutrition_facts_protein'
            },

            {
                name: 'calfat',
                type: '',
                min: 'weekly_min_nutrition_facts_calfat',
                max: 'weekly_max_nutrition_facts_calfat',
                unit: '',
                column_name: 'nutrition_facts_calfat'
            },

            {
                name: 'transfat',
                type: '',
                min: 'weekly_min_nutrition_facts_transfat',
                max: 'weekly_max_nutrition_facts_transfat',
                unit: '',
                column_name: 'nutrition_facts_transfat'
            },

            {
                name: 'polysatfat',
                type: '',
                min: 'weekly_min_nutrition_facts_polysatfat',
                max: 'weekly_max_nutrition_facts_polysatfat',
                unit: '',
                column_name: 'nutrition_facts_polysatfat'
            },
            {
                name: 'monosatfat',
                type: '',
                min: 'weekly_min_nutrition_facts_monosatfat',
                max: 'weekly_max_nutrition_facts_monosatfat',
                unit: '',
                column_name: 'nutrition_facts_monosatfat'
            },
            {
                name: 'cholesterol',
                type: '',
                min: 'weekly_min_nutrition_facts_cholesterol',
                max: 'weekly_max_nutrition_facts_cholesterol',
                unit: '',
                column_name: 'nutrition_facts_cholesterol'
            },
            {
                name: 'potassium',
                type: '',
                min: 'weekly_min_nutrition_facts_potassium',
                max: 'weekly_max_nutrition_facts_potassium',
                unit: 'mg',
                column_name: 'nutrition_facts_potassium'
            },
            {
                name: 'fiber',
                type: '',
                min: 'weekly_min_nutrition_facts_fiber',
                max: 'weekly_max_nutrition_facts_fiber',
                unit: 'g',
                column_name: 'nutrition_facts_fiber'
            },
            {
                name: 'sugar',
                type: '',
                min: 'weekly_min_nutrition_facts_sugar',
                max: 'weekly_max_nutrition_facts_sugar',
                unit: 'g',
                column_name: 'nutrition_facts_sugar'
            },
            {
                name: 'vitamina',
                type: '',
                min: 'weekly_min_nutrition_facts_vitamina',
                max: 'weekly_max_nutrition_facts_vitamina',
                unit: 'mcg RAE',
                column_name: 'nutrition_facts_vitamina'
            },
            {
                name: 'vitaminb6',
                type: '',
                min: 'weekly_min_nutrition_facts_vitaminb6',
                max: 'weekly_max_nutrition_facts_vitaminb6',
                unit: 'mg',
                column_name: 'nutrition_facts_vitaminb6'
            },
            {
                name: 'vitaminb12',
                type: '',
                min: 'weekly_min_nutrition_facts_vitaminb12',
                max: 'weekly_max_nutrition_facts_vitaminb12',
                unit: 'mcg',
                column_name: 'nutrition_facts_vitaminb12'
            },
            {
                name: 'vitaminc',
                type: '',
                min: 'weekly_min_nutrition_facts_vitaminc',
                max: 'weekly_max_nutrition_facts_vitaminc',
                unit: 'mg',
                column_name: 'nutrition_facts_vitaminc'
            },
            {
                name: 'vitamind',
                type: '',
                min: 'weekly_min_nutrition_facts_vitamind',
                max: 'weekly_max_nutrition_facts_vitamind',
                unit: 'mcg',
                column_name: 'nutrition_facts_vitamind'
            },
            {
                name: 'vitamine',
                type: '',
                min: 'weekly_min_nutrition_facts_vitamine',
                max: 'weekly_max_nutrition_facts_vitamine',
                unit: 'mg',
                column_name: 'nutrition_facts_vitamine'
            },
            {
                name: 'calcium',
                type: '',
                min: 'weekly_min_nutrition_facts_calcium',
                max: 'weekly_max_nutrition_facts_calcium',
                unit: 'mg',
                column_name: 'nutrition_facts_calcium'
            },
            {
                name: 'iron',
                type: '',
                min: 'weekly_min_nutrition_facts_iron',
                max: 'weekly_max_nutrition_facts_iron',
                unit: 'mg',
                column_name: 'nutrition_facts_iron'
            },
            {
                name: 'magnesium',
                type: '',
                min: 'weekly_min_nutrition_facts_magnesium',
                max: 'weekly_max_nutrition_facts_magnesium',
                unit: 'mg',
                column_name: 'nutrition_facts_magnesium'
            },
            {
                name: 'coblamin',
                type: '',
                min: 'weekly_min_nutrition_facts_coblamin',
                max: 'weekly_max_nutrition_facts_coblamin',
                unit: 'mg',
                column_name: 'nutrition_facts_coblamin'
            },
            {
                name: 'thiamin',
                type: '',
                min: 'weekly_min_nutrition_facts_thiamin',
                max: 'weekly_max_nutrition_facts_thiamin',
                unit: 'mg',
                column_name: 'nutrition_facts_thiamin'
            },
            {
                name: 'riboflavin',
                type: '',
                min: 'weekly_min_nutrition_facts_riboflavin',
                max: 'weekly_max_nutrition_facts_riboflavin',
                unit: 'mg',
                column_name: 'nutrition_facts_riboflavin'
            },
            {
                name: 'niacin',
                type: '',
                min: 'weekly_min_nutrition_facts_niacin',
                max: 'weekly_max_nutrition_facts_niacin',
                unit: 'mg',
                column_name: 'nutrition_facts_niacin'
            },
            {
                name: 'zinc',
                type: '',
                min: 'weekly_min_nutrition_facts_zinc',
                max: 'weekly_max_nutrition_facts_zinc',
                unit: 'mg',
                column_name: 'nutrition_facts_zinc'
            },
            {
                name: 'water',
                type: '',
                min: 'weekly_min_nutrition_facts_water',
                max: 'weekly_max_nutrition_facts_water',
                unit: 'g',
                column_name: 'nutrition_facts_water'
            },
            {
                name: 'ash',
                type: '',
                min: 'weekly_min_nutrition_facts_ash',
                max: 'weekly_max_nutrition_facts_ash',
                unit: 'g',
                column_name: 'nutrition_facts_ash'
            }
            ],

            weekly_calculated_checkboxes: [
                "CALS",
                "SOD",
                "added_sugars",
                "CALS (%)",
                "satfat",
                "SATFAT (%)",
                "CARB",
                "FAT",
                "PROT",
                
                "calfat",

                "transfat",
                "polysatfat",
                "monosatfat",
                "cholesterol",
                "potassium",
                "fiber",
                "sugar",
                "vitamina",
                "vitaminb6",
                "vitaminb12",
                "vitaminc",
                "vitamind",
                "vitamine",
                "calcium",
                "iron",
                "magnesium",
                "coblamin",
                "thiamin",
                "riboflavin",
                "niacin",
                "zinc",
                "water",
                "ash",

            ],

            weekly_calculated_totals: ["CALS", "SOD", "added_sugars", "CALS (%)",  "satfat", "SATFAT (%)", "CARB"],
            ShowHideCheckboxesCheck: false,
        };
    },



    // mounted() {
    //     console.log('oksss');
    //     for (let keyff in this.weeklyAvg) {
    //         console.log("ttttt" + keyff);
    //     }

    // },

    methods: {

        ShowHideCheckboxes() {
            // this.CalucateSatFatAndCalsPercentate();
            // console.log('yyyy', this.weeklyAvg);
            this.ShowHideCheckboxesCheck = !this.ShowHideCheckboxesCheck;
        },
        onClickOutside() {
            this.ShowHideCheckboxesCheck = false;
        },

        showWarningHover() {
            // console.log(this.datas);
            let gline = this.guideline_data;

            let returnText = [];
            for (let i = 0; i < this.datas.length; i++) {
                //parseFloat(weeklyAvg.MMA), 'component')
                let gValid = this.checkGuildLineVals(gline[this.datas[i]['min']], gline[this.datas[i]['max']], parseFloat(this.weeklyAvg[this.datas[i]['name']]), this.datas[i]['type']);
                // console.log("showWarningHover", gValid);
                if (gValid == 'red') {
                    if (this.datas[i]['name'] === 'sugar') {
                        
                        returnText.push('Total Sugar' + ': ' + this.$helpers.nearestValue(parseFloat(this.weeklyAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']])); 
                    } else if (this.datas[i]['name'] === 'CALS (%)') {
                        returnText.push('Add. Sugar %' + ': ' + this.$helpers.nearestValue(parseFloat(this.weeklyAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']])); 
                    } else {
                        returnText.push(this.datas[i]['name'] + ': ' + this.$helpers.nearestValue(parseFloat(this.weeklyAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']]));
                    }
                    
                }
            }

            // getAllRecipes
            // console.log('showWarningHover', returnText);
            returnText = this.$helpers.getAdditionalProducts(gline, this.getAllRecipes, returnText, 'weekly');

            return returnText;
        },

        showMinMax(min, max) {
            let gline = this.guideline_data;
            // console.log("guideline_data", this.guideline_data);
            var rText = 'Minimum: ';
            if (gline[min] && gline[min] > 0) {
                rText += gline[min];
            } else {
                rText += 'n/a';
            }
            rText += ', Maximum: ';
            if (gline[max] && gline[max] > 0) {
                rText += gline[max];
            } else {
                rText += 'n/a';
            }
            return rText;
        },
        roundTwoDecimals(result) {
            return (result).toFixed(2);
        },

        addName(vals, name) {
            let t = '';
            
            if(this.override_components && this.override_components.includes(name)){
                t = '⟡';
            } 
            // console.log('addName1', this.override_components, name, t, this.override_components.includes(name));

            if (vals > 0) {
                return vals + ' ' + t;
            } else {
                if(t == '⟡'){
                    return '⟡';
                } else {
                    return ' - ';
                }
                
            }
        },
        //     if (vals > 0) {
        //         return vals;
        //     } else {
        //         return ' - ';
        //     }
        // },
        addNameStar(vals, name) {
            let t = '';
            let override_t = '';
            // console.log('addNameStar', name);
            if(this.null_nutrient && this.null_nutrient.includes(name)){
                t = '*';
            } 

            let override_nut = {'nutrition_facts_calories': 'CALS',
                'nutrition_facts_sodium': 'SOD',
                'nutrition_facts_added_sugars': 'SUG',
                'nutrition_facts_satfat': 'nutrition_facts_satfat',
                'nutrition_facts_carbs': 'CARB'
            };

            if(override_nut[name] &&  this.override_components && this.override_components.includes(override_nut[name])){
                override_t = ' ⟡';
            }
            if (vals > 0) {
                return vals + ' ' + t + override_t;
            } else {
                if(t == '*'){
                    return '*'+ override_t;
                } else {
                    return ' - ';
                }
                
            }
        },
        checkGuildLineVals(gMin, gMax, cVal, cType) {

            // console.log("checkGuildLineVals gMin, gMax, cVal  ", this.$helpers.checkGuildLineVals(gMin, gMax, cVal, cType), gMin, gMax, cVal, cType);
            return this.$helpers.checkGuildLineVals(gMin, gMax, cVal, cType);
            // check guildline min or max value for is not null or 0
            if (this.$helpers.checkIntOrNotNull(gMin) || this.$helpers.checkIntOrNotNull(gMax)) {
                let returnVal = 'green';
                // check guidline min value is not null or 0
                if (this.$helpers.checkIntOrNotNull(gMin)) {

                    // check guidline min value <= cVal
                    if (this.$helpers.checkIntOrNotNull(cVal) && gMin <= cVal) {
                        // return 'green';
                    } else {
                        console.log("this.$helpers.checkIntOrNotNull(cVal)", this.$helpers.checkIntOrNotNull(cVal));
                        return 'red';
                    }
                }

                // check guidline max value is not null or 0
                if (this.$helpers.checkIntOrNotNull(gMax)) {
                    // check guidline max value <= cVal
                    if (this.$helpers.checkIntOrNotNull(cVal) && gMax >= cVal) {
                        // returnVal = 'green';
                    } else {
                        if (cType == 'component') {
                            returnVal = 'gray';

                        } else {
                            returnVal = 'red';
                        }

                    }
                }
                return returnVal;
            } else {
                return 'gray';
            }
        }
    },
    computed: {

        hasValue() {
            return (value) => this.weekly_calculated_totals.includes(value);
        }
    }

};
</script>
